// import node_modules
import * as React from 'react';
import * as PropTypes from 'prop-types';

// import styles
import styles from './TableOfContents.module.css';

// define component
const TableOfContents: React.FunctionComponent<{
  items: { id: string; label: string }[];
}> = ({ items }) => {
  // init func
  const onScrollToSection = React.useCallback(
    (event: React.MouseEvent | React.TouchEvent, itemId: string) => {
      event.preventDefault();
      const section = document.getElementById(itemId);
      if (section) {
        const offset = 64; // nav height
        window.scroll({ top: section.offsetTop - offset, left: 0, behavior: 'smooth' });
      }
    },
    [],
  );

  // init render
  return (
    <div className={styles['storyliner-toc-container']}>
      <div className={styles['storyliner-toc-menu']}>
        {items.map((item) => (
          <div className={styles['storyliner-toc-item-container']} key={item.id}>
            <button
              className={styles['storyliner-toc-item']}
              onClick={(event) => onScrollToSection(event, item.id)}
              type="button"
            >
              {item.label}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

TableOfContents.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, label: PropTypes.string.isRequired })
      .isRequired,
  ).isRequired,
};

export default TableOfContents;
